










































import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";
import _ from "lodash";
import { DxButton } from "devextreme-vue/ui/button";
import { DxPopup } from "devextreme-vue";
import TableGrid from "@/components/TableGrid/grid.vue";
import TariffHistoryService, {route_ns} from "@/services/tariff-history-service";
import TariffService from "@/services/tariff-service";
import UserService from "@/services/data/user_manager";
import TariffHistoryDetailPopup from "@/views/tarifs/components/tariff-history-detail-popup.vue"
import base_ds from "@/services/base_datasource_service";


@Component({
  name: "TariffHistoryPopup",
  components: {
    DxButton,
    DxPopup,
    TableGrid,
    TariffHistoryDetailPopup,

  }
})
export default class extends Vue {
  @PropSync('popupOptions') public localPopupOptions: any;
  @Prop() public cutId: any;
  @Prop() public nodeId: any;

  public data_source = base_ds.getBaseDataSource(route_ns);

  public service = TariffHistoryService;
  public tariffService = TariffService;
  public userService = UserService;

  public columns: Array<any> = [];

  public tariffHistoryDetailPopup = {
    visible: false,
  }

  async created() {
    this.data_source = base_ds.getBaseDataSource(route_ns, 'id',
      [["id_cut","=",this.cutId],"and",["id_eco_heat_node","=",this.nodeId]]);
    this.initColumns();

  }

  async mounted() {

  }

  async onShowing() {

  }

  initColumns() {
    this.columns = [
      {
        dataField: 'id',
        visible: false
      },
      {
        dataField: 'date_created',
        caption: 'Дата',
        sortOrder: 'desc',
        dataType: 'datetime',
        width: '150px',

      },
      {
        dataField: 'modified_by_id',
        caption: 'Пользователь',
        lookup: {
          dataSource: this.userService.userDataSource.store(),
          valueExpr: 'id',
          displayExpr: 'full_name'
        },

      },
      {
        dataField: 'tariff_description',
        caption: 'Тариф',
        dataType: 'string',

      },
      {
        dataField: 'crud_type',
        caption: 'Действие',
        calculateCellValue: this.calculateAction,
    
      },
      {
        maxWidth: '200',
        type: 'buttons',
        caption: '',
        buttons: [
          {
            icon: 'comment',
            hint: 'Детальный просмотр',
            onClick: this.dblRowClick
          },
        ]
      }

    ]
  }

  onShow() {
    //
  }

  rowClick(e: any) {
    this.service.setCurrent(e.data);
  }

  dblRowClick(e: any) {
    // Если функция вызывается из обработчика нажатия кнопки
    if (e?.row?.data) {
      this.service.setCurrent(e.row.data);
    }
    this.tariffHistoryDetailPopup.visible = true;

  }

  onClose() {

    this.localPopupOptions.visible = false;
  }

  calculateAction(rowData: any): string {
    let res = '';
    if (rowData.crud_type === 1) {
      res = 'Создание'
    }
    else if (rowData.crud_type === 2) {
      res = 'Редактирование'
    }
    else if (rowData.crud_type === 3) {
      res = 'Удаление'
    }
    return res;
  }

  empty() {

  }


}
